import React, { Component, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import app from '../../../plugins/routes/app';
import { connect } from 'react-redux';

import List from "./Trip/TripList"

class Trip extends Component {

    render() {
        let trips = app.routes.find(x => x.name === 'trips');
        return (
            <Fragment>
                <Switch>
                    <Route exact path="/app/trips" component={List} />
                    {trips.routes.map((route, key) => {
                        return <Route
                            path={`${app.path}${trips.path}${route.path}`}
                            meta={route.meta}
                            component={route.component}
                            key={key}
                        />;
                    })}
                </Switch>
            </Fragment>

        )
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(Trip);


// WEBPACK FOOTER //
// ./src/components/App/Views/Trip.js